import React, { useEffect } from 'react';
import { Button, Skeleton } from "antd";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import { getMyOrdersApi } from "../../redux-toolkit/slices/orderCreamSlice";
import { formatDateMonthDayYear } from "../../helpers/date";

const PastOrders = () => {
  const dispatch = useAppDispatch();
  const { orders, isLoading } = useSelector(
    (state: RootState) => state.orderCream
  );

  useEffect(() => {
    dispatch(getMyOrdersApi());
  }, [dispatch]);

  const displayOrders = orders ? orders.slice(0, 3) : [];

  return (
    <div className="bg-white p-6 w-full" style={{ border: '1px solid var(--neutral-300)', borderRadius: '32px' }}>
      <div className="flex justify-between items-center mb-2">
        <h3 className="h4 text-[var(--theme-text-primary)] mb-0" style={{ fontWeight: 600 }}>
          Order History
        </h3>
        <Link to="/orders">
            <Button 
            type="link"
            className="hover:text-[var(--primary-600)] transition-colors p-0 shadow-none"
            style={{ 
                fontFamily: 'var(--font-body1-fontFamily)', 
                height: 'auto', 
                border: 'none', 
                outline: 'none', 
                boxShadow: 'none',
                color: 'var(--primary-500)',
                fontWeight: 700,
                fontSize: '15px'
            }}
            >
            View All
            </Button>
        </Link>
      </div>
      
      <div className="flex flex-col gap-5">
        {isLoading ? (
             <>
                <Skeleton active paragraph={{ rows: 1 }} />
                <Skeleton active paragraph={{ rows: 1 }} />
                <Skeleton active paragraph={{ rows: 1 }} />
             </>
        ) : displayOrders.length > 0 ? (
            displayOrders.map((order, index) => (
            <div key={index} className="flex flex-col">
                <span className="font-semibold text-[var(--theme-text-primary)] leading-tight mb-1" style={{ fontFamily: 'var(--font-body1-fontFamily)', fontSize: '16px' }}>
                    {formatDateMonthDayYear(order.createdAt)}
                </span>
                <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[var(--primary-500)]"></span>
                <h6 className="h6 text-theme-text-secondary mb-0">
                    {order.processingDetails.orderStatus}: Rx {order.processingDetails.orderNumber}
                </h6>
                </div>
            </div>
            ))
        ) : (
            <div className="text-theme-text-secondary">No past orders found.</div>
        )}
      </div>
    </div>
  );
};

export default PastOrders;
